// extracted by mini-css-extract-plugin
module.exports = {"usecasesWrapper":"UseCases_usecasesWrapper__1jP8R","navLeft":"UseCases_navLeft__3RWCm","navRight":"UseCases_navRight__1mnVI"};